import type { SVGProps } from 'react';

const SvgPlayerZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17.31 15.89a7.96 7.96 0 0 0 1.69-4.9c0-4.41-3.59-8-8-8S3 6.59 3 11s3.59 8 8 8c1.85 0 3.54-.63 4.9-1.69l3.4 3.4c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM5 11c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6"
    />
    <path
      fill="currentcolor"
      d="M14 10H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgPlayerZoomOut;
